// extracted by mini-css-extract-plugin
export default {"legendItem":"LegendItem_legendItem__lqrFf","colorBlock":"LegendItem_colorBlock__V3d64"};